import _extends from "@babel/runtime/helpers/extends";
import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { Button as ButtonComponent } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { getWindow } from "../../../../../../../../utils/window";
import { ymPushParams } from "../../../../../../../../utils/ym.alternative";
import { getAccountType } from "../../../../../../../../utils/analytics";
import { getContent } from "../../../../../../../dependencies/getContent/dev";
import { getIsMobile } from "../../../../../../../dependencies/getIsMobile/dev";
import { getUserAccountInfo } from "../../../../../../../dependencies/getUserAccountInfo/dev";
import { submitPayment } from "../../../../../../../dependencies/submitPayment/dev";
import styles from "./styles.pcss";
import { getAnalyticsConverter } from "./analytics";
import { getMapStateToPaymentButtonProps } from "./logic/logic";
import { getIsBeelineError } from "../../PaymentDetailsSection/InputSection/components/PhoneInput/dependencies/getIsBeelineError/dev";

/**
 * Set up dependencies for the payment submit button state mapping.
 *
 * NOTE: Index files are responsible for connecting dependencies to their respective logic
 * This approach uses a hierarchical composition pattern, where dependencies are organized
 * at the same level as their corresponding components. This keeps the codebase modular
 * and easier to maintain.
 * The top-level index.ts file gathers dependencies from the index.ts files of other components
 * and composes them following the same hierarchy as the components.
 * */
export var mapStateToPaymentButtonProps = getMapStateToPaymentButtonProps({
  getContent: getContent,
  submitPayment: submitPayment,
  getIsBeelineError: getIsBeelineError,
  getIsMobile: getIsMobile,
  getUserAccountInfo: getUserAccountInfo
});
var cn = classNames.bind(styles);
var analyticsConverter = getAnalyticsConverter({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
});

// @ts-expect-error withDataConverter without .d.ts
export var Button = compose(withDataConverter(analyticsConverter))(function (props) {
  return /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, props, {
    className: cn('button'),
    size: "l",
    width: props.width || 'full',
    "data-t-id": "PaymentMethodSection-Button"
  }));
});